import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useFetch } from '@rad/hooks';
import { fetchUserEventsPage, getUserEventFilters } from '../../../common/network/event-store';
import EventActivity from '../../_shared/components/event-activity';
// Mounted with its tab, so its fetch runs only while the tab is open.
const UserActivityTab = (props) => {
    const { userId } = props;
    const [filtersPromise] = useFetch(getUserEventFilters(userId));
    const fetchPage = useCallback((search, eventTypes, _userIds, dateFrom, dateTo) => fetchUserEventsPage(userId, search, eventTypes, dateFrom, dateTo), [userId]);
    return (_jsx(EventActivity, { fetchPage: fetchPage, filtersPromise: filtersPromise, showUserFilter: false }));
};
export default UserActivityTab;
